import { appUrl } from 'utils/wrappers';

import ReportsBase from 'app/collections/reports_base';
import CashFlowReport from 'app/models/cash_flow_report';

export default ReportsBase.extend({
  model: CashFlowReport,
  url: appUrl('reports/cash_flow'),
});



// WEBPACK FOOTER //
// ./app/collections/cash_flow_reports.js